import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  Button,
  Row,
  Col,
  Checkbox,
  Form,
  DatePicker,
  Table,
  message,
  Typography,
} from "../../common/utils/antd-imports/AntdImports";
import { Input, Select, Spin } from "antd";
import moment from "moment-timezone";
import "./AddBillBoard.css";
import { ReactComponent as CalenderIcon } from "../../../assests/Billboard_Calender_Icon.svg";
import { ReactComponent as AddIcon } from "../../../assests/add-icon-white.svg";
import { useDispatch, useSelector } from "react-redux";
import FloatingInput from "../float-input/FloatInput";
import IconFloatingInput from "../icon-float-input/IconFloatInput";
import FloatingTextArea from "../floating-textarea/FloatingTextArea";
import { ReactComponent as Delete } from "../../../assests/delete_icon.svg";
import {
  getChannelsFromProductType,
  getOwnerProducts,
  getProductDetails,
  saveClonedProductDetails,
  saveProductDetails,
} from "../../../store/thunks/seller-thunks/SellerThunk";
import FloatingSelect from "../floating-select/floatingSelect";
import { searchLocation } from "../../../store/thunks/authThunk";
import FormItem from "antd/es/form/FormItem";
import dayjs from "dayjs";
import { useMediaQuery } from "react-responsive";
import {
  RESET_PRODUCT,
  RESET_STATUS,
} from "../../../store/slices/common-slice/products/ProductSlice";
import BillboardImageUploader from "./BillboardImageUploader";
import { formatToUSCurrency } from "../utils/Utils";
import { useNavigate } from "react-router-dom";
import { CloseCircleOutlined } from "@ant-design/icons";
const { RangePicker } = DatePicker;
const { Text } = Typography;

const AddBillBoard = ({
  form,
  id,
  isClone = false,
  setMobileOpenDialog,
  isDashboardProduct = false,
  mobileOpenDialog,
  setOpenDialog,
  openDialog,
  setIsCloneProduct,
  setSelectedProduct,
  setCurrentPage,
  billBoardText,
}) => {
  const isMobile = useMediaQuery({ maxWidth: 769 });
  const dispatch = useDispatch();
  const user = localStorage.getItem("user");
  const [files, setFiles] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [productTypeList, setProductTypeList] = useState([]);
  const [rateCardPrice, setRateCardPrice] = useState(0);
  const fileInputRef = useRef(null);
  const [isVariable, setIsVariable] = useState(true);
  const [ampBills, setAmpBills] = useState(true);
  const [ampServices, setAmpServices] = useState(true);
  const [binaryImages, setBinaryImages] = useState([]);
  const [selectedProductType, setSelectedProductType] = useState("Static");
  const [dmaLocations, setDmaLocations] = useState([]);
  const [isSponsored, setIsSponsored] = useState(false);
  const [noOfDaysSelected, setNoOfDaysSelected] = useState({});
  const star = <span style={{ color: "#d2042d" }}>*</span>;
  const [searchText, setSearchText] = useState("");
  const [selectedDmaChanged, setSelectedDmaChanged] = useState(false);
  const [percentages, setPercentages] = useState({});
  const [totalPercentage, setTotalPercentage] = useState(0);
  const [amounts, setAmounts] = useState({});
  const selectedArea = Form.useWatch("area", form);
  const navigate = useNavigate();
  const {
    productChannelsList,
    isLoading: isLoadingProducts,
    status,
    product,
  } = useSelector((state) => state.products);
  const [availabilityRanges, setAvailabilityRanges] = useState([
    {
      id: 1,
      dates: null,
    },
  ]);
  const { isLoading: deleteImageLoader } = useSelector(
    (state) => state.sellerCampaigns,
  );
  const { locationDma, isLoading: isLoadingLocation } = useSelector(
    (state) => state.location,
  );
  const isLoading = isLoadingProducts || deleteImageLoader;
  const floatingInputStyles = {
    marginTop: "0px",
    "--input-font-weight": "500",
    "--label-focused-top": "20px",
    "--label-focused-z-index": 1,
    "--label-focused-color": "#333",
    "--label-padding-left": "0.5rem",
  };
  const floatingSelectStyles = {
    marginTop: "0px",
    "--input-font-weight": "500",
    "--label-focused-top": "23px",
    "--label-focused-z-index": 1,
    "--label-focused-color": "#333",
    "--label-padding-left": "0.6rem",
    "--input-padding-top": "1rem",
  };
  const iconFloatingInputStyles = {
    marginTop: "0px",
    "--input-font-weight": "500",
    "--label-focused-top": "19px",
    "--label-focused-z-index": 2,
    "--label-focused-color": "#333",
    "--label-padding-left": "2rem",
  };
  const textAreaFloatingInputStyles = {
    "--input-height": "120px",
    "--label-font-size": "10px",
    "--input-font-weight": 500,
    "--input-padding-top": "1rem",
    "--label-focused-top": "22px",
    "--label-focused-z-index": 1,
    "--label-focused-color": "#333",
    "--label-padding-left": "10px",
  };
  const data = [
    {
      key: "1",
      category: "18-49",
    },
    {
      key: "2",
      category: "18+",
    },
    {
      key: "3",
      category: "25-54",
    },
    {
      key: "4",
      category: "Hispanic Adults-HA54",
    },
  ];
  const [paymentTermsData, setPaymentTermsData] = useState([
    {
      key: "1",
      term: "",
      percentage: "",
      days: 0,
    },
  ]);
  const paymentTerms = [
    "stripe_percent",
    "net_7_percent",
    "net_30_percent",
    "net_90_percent",
  ];
  const impressionNames = [
    "firstImpression",
    "secondImpression",
    "thirdImpression",
    "forthImpression",
  ];

  const cpmNames = useMemo(
    () => ["firstcpm", "cpm", "thirdcpm", "forthcpm"],
    [],
  );

  const cpmCalculation = (value, rateCard) => {
    const dates =
      form.getFieldValue("startAndEndDate") ||
      availabilityRanges.find((range) => range?.value?.[0] && range?.value?.[1])
        ?.value;
    if (
      value === "" ||
      value == null ||
      Number(value) < 7 ||
      !Number(rateCard) ||
      !dates?.[0] ||
      !dates?.[1]
    ) {
      return "";
    }
    const daysDifference = dates[1].diff(dates[0], "day") + 1;
    const impressionValue = Math.floor(Number(value) / 7) * daysDifference;
    if (!impressionValue || daysDifference <= 0) return "";
    const result =
      ((Number(rateCard) / 28) * daysDifference * 1000) / impressionValue;
    return Number.isFinite(result) ? result : "";
  };

  const columns = [
    {
      title: "Age Group",
      dataIndex: "category",
      key: "category",
    },
    {
      title: "Impressions(1 Week)",
      dataIndex: "impressions",
      key: "impressions",
      render: (_text, record, index) => (
        <FormItem
          name={impressionNames[index]}
          rules={[
            ...(index === 1
              ? [{ required: true, message: "Second impression is required!" }]
              : []),
            {
              validator: (_, value) => {
                if (value === undefined || value === null || value === "") {
                  return Promise.resolve();
                }
                if (Number(value) >= 7) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error("Impressions must be at least 7"),
                );
              },
            },
          ]}
        >
          <FloatingInput
            className="billboard-input-feild"
            type="number"
            onWheel={(e) => e.target.blur()}
            onChange={(e) => {
              const cpmValue = cpmCalculation(
                e.target.value,
                form.getFieldValue("rateCard"),
              );
              form.setFieldsValue({
                [cpmNames[index]]: `${
                  cpmValue ? Number(cpmValue || 0)?.toFixed(2) : ""
                }`,
              });
            }}
            label={
              index === 1 ? (
                <>
                  {`Impressions `}
                  {star}
                </>
              ) : (
                <>{`Impressions `}</>
              )
            }
            customStyles={floatingInputStyles}
          />
        </FormItem>
      ),
    },
    {
      title: "CPM(Cost per Thousand Impressions)",
      dataIndex: "address",
      key: "address",
      render: (_text, record, index) => (
        <FormItem name={cpmNames[index]}>
          <IconFloatingInput
            disabled
            innerClassName="inner-payment-term"
            className="payment-term"
            value={form.getFieldValue(cpmNames[index]) || "NaN"}
            label={<>{`CPM `}</>}
            customStyles={iconFloatingInputStyles}
          ></IconFloatingInput>
        </FormItem>
      ),
    },
  ];

  const handleSearch = (value) => {
    setSearchText(value);
    if (!value) {
      setDmaLocations([]);
      form.setFieldsValue({ area: undefined });
      return;
    }
  };

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (searchText) {
        dispatch(searchLocation(searchText));
      }
    }, 500);

    return () => {
      clearTimeout(delayDebounce);
    };
  }, [searchText]);

  useEffect(() => {
    if (locationDma) {
      const v =
        locationDma &&
        locationDma?.map((location, index) => ({
          label: `${location.city_name} - ${location.name}`,
          value: location.id,
          state: location.state_name,
          timeZone: location.area_time_zone_type,
          offSet: location.area_time_zone,
          streetaddress: location.name,
          pincode: location.pincode,
          lat: location.lat,
          lng: location.lng,
        }));
      setDmaLocations(v);
    }
  }, [locationDma]);

  const formatDateRange = (dates) => {
    if (!dates || dates.length !== 2) return "";
    return `${moment(dates[0].$d).format("DD-MMM-YY")} to ${moment(
      dates[1].$d,
    ).format("DD-MMM-YY")}`;
  };

  useEffect(() => {
    if (status === "success") {
      dispatch(RESET_STATUS());
      if (isClone) {
        setIsCloneProduct(false);
      }
      if (isMobile) {
        setMobileOpenDialog(false);
      } else {
        setOpenDialog(false);
      }
      if (isDashboardProduct) {
        let payload = {
          budget: "",
          dma: "",
          format: { name: "All" },
          page_no: 1,
          page_size: 15,
          product_name: "",
          show_available: false,
        };
        dispatch(getOwnerProducts(payload));
      }
    }
  }, [status]);

  const handleSaveDetails = (values) => {
    const total = paymentTermsData.reduce(
      (sum, item) => sum + (parseFloat(item?.percentage) || 0),
      0,
    );

    if (total !== 100) {
      message.error(
        `Total payment term percentages must equal 100% (currently ${total}%)`,
      );
      return;
    }

    const formData = new FormData();

    // Payment terms - use the latest paymentTermsData values
    // Payment terms - always send all payment fields
    // Active terms get their current percentage.
    // Previous/removed terms are reset to 0.
    const paymentTermFieldMap = {
      UPFRONT: "stripe_percent",
      WEEKLY: "net_7_percent",
      MONTHLY: "net_30_percent",
      QUARTERLY: "net_90_percent",
    };

    const paymentTermValues = {
      stripe_percent: 0,
      net_7_percent: 0,
      net_30_percent: 0,
      net_90_percent: 0,
    };

    paymentTermsData.forEach((item) => {
      if (!item?.term) return;

      const fieldName = paymentTermFieldMap[item.term?.toUpperCase()];
      const value = parseFloat(item?.percentage);

      if (fieldName && !isNaN(value)) {
        paymentTermValues[fieldName] = value;
      }
    });

    Object.entries(paymentTermValues).forEach(([fieldName, value]) => {
      formData.append(fieldName, value.toString());
    });

    const locationDma = form.getFieldValue("area")
      ? dmaLocations?.find(
          (location) => location.value === form.getFieldValue("area"),
        )
      : undefined;

    if (selectedDmaChanged) {
      values.area = product?.area;
    } else {
      values.area = locationDma?.value;
    }

    const feilds = values;
    const unitQtyArray = [];

    // multi slot values from claendar
    availabilityRanges.forEach((range, index) => {
      if (range?.value) {
        const startDate = range.value[0].format("YYYY-MM-DDTHH:mm:ss[Z]");
        const endDate = range.value[1].format("YYYY-MM-DDTHH:mm:ss[Z]");

        formData.append(`dates[${index}][startDate]`, startDate);
        formData.append(`dates[${index}][endDate]`, endDate);

        if (selectedProductType === "Digital") {
          unitQtyArray.push(Number(range.unitQty));
        }
      }
    });

    if (selectedProductType === "Digital") {
      unitQtyArray.forEach((qty, index) => {
        formData.append(`unitQty[${index}]`, qty);
      });
    } else {
      // Single quantity for all slots
      formData.append("unitQty", availabilityRanges[0]?.unitQty || "");
    }

    if (files?.length > 0 && files?.length < 4) {
      files?.forEach((file, index) => {
        if (typeof file === "string") {
          formData.append(`prevImages[${index}]`, file);
        }
      });

      binaryImages.forEach((blob, index) => {
        formData.append(`image[${index}]`, blob.binary, blob.name);
      });

      formData.append("default_image_type", "Upload");
    } else {
      formData.append("image", "");
    }

    if (product) {
      formData.append("id", product?.id);
    }

    if (selectedDmaChanged) {
      formData.append("city", product?.city);
    } else {
      formData.append("city", locationDma?.label);
    }

    if (selectedProductType !== "Media") {
      formData.append("height", `${feilds.height} ${feilds.pixels}`);
      formData.append("width", `${feilds.width} ${feilds.pixels}`);
    }

    formData.append("product_visibility", 0);

    "billingYes" in feilds
      ? formData.append("billingNo", feilds.billingNo ? feilds.billingNo : "")
      : formData.append(
          "billingYes",
          feilds.billingYes ? feilds.billingYes : "",
        );

    "servicingYes" in feilds
      ? formData.append(
          "servicingNo",
          feilds.servicingNo ? feilds.servicingNo : "",
        )
      : formData.append(
          "servicingYes",
          feilds.servicingYes ? feilds.servicingYes : "",
        );

    Object.keys(feilds).forEach((key) => {
      if (
        key !== "startAndEndDate" &&
        key !== "pixels" &&
        key !== "height" &&
        key !== "width" &&
        ![
          "stripe_percent",
          "net_7_percent",
          "net_15_percent",
          "net_30_percent",
          "net_45_percent",
          "net_60_percent",
          "net_90_percent",
        ].includes(key)
      ) {
        formData.append(key, feilds[key] ?? "");
      }
    });

    if (isClone) {
      dispatch(saveClonedProductDetails(formData)).then(() => {
        setIsCloneProduct(false);
        setSelectedProduct(null);
        setCurrentPage(1);
      });
    } else {
      dispatch(saveProductDetails(formData)).then(() => {
        setSelectedProduct(null);
        setCurrentPage(1);

        if (isDashboardProduct) {
          navigate("/seller/myproducts");
        }
      });
    }
  };

  const getChannelsById = (id) => {
    const channel = productChannelsList?.find((channel) => channel?.id === id);
    return channel
      ? `${channel?.channel_name} - ${channel?.sub_channel_name}`
      : "";
  };

  const iconPaymentTermsFloatingInputStyles = {
    marginTop: "0px",
    "--input-font-weight": "500",
    "--label-focused-top": "19px",
    "--label-focused-z-index": 2,
    "--label-focused-color": "#333",
    "--label-padding-left": "0rem",
  };

  const paymentTermFieldMap = {
    UPFRONT: "stripe_percent",
    WEEKLY: "net_7_percent",
    MONTHLY: "net_30_percent",
    QUARTERLY: "net_90_percent",
  };

  useEffect(() => {
    const newAmounts = {};
    let newTotalPercentage = 0;
    const newActiveTerms = [];
    // First pass: calculate total and identify active terms
    Object.entries(percentages).forEach(([term, percentage]) => {
      const numPercentage = percentage || 0;
      newAmounts[term] =
        (numPercentage / 100) *
        (form.getFieldValue("rateCard") || rateCardPrice);
      newTotalPercentage += numPercentage;

      // Track terms with values
      if (numPercentage > 0) {
        newActiveTerms.push(term);
      }
    });
    setAmounts(newAmounts);
    setTotalPercentage(newTotalPercentage);
  }, [percentages, rateCardPrice]);

  const PercentageCalculation = (term, value) => {
    const updatedPercentages = {};
    if (value == 100) {
      const resetPercentages = {};
      paymentTerms.forEach((t) => {
        const isCurrent = t === term;
        resetPercentages[t] = isCurrent ? 100 : undefined;
        form.setFieldsValue({
          [t]: isCurrent ? 100 : undefined,
        });
      });
      setPercentages(resetPercentages);
      return;
    }
    paymentTerms.forEach((term) => {
      updatedPercentages[term] = parseFloat(form.getFieldValue(term)) || 0;
    });
    setPercentages(updatedPercentages);

    const total = Object.values(updatedPercentages).reduce(
      (acc, val) => acc + val,
      0,
    );
    setTotalPercentage(total);

    const updatedAmounts = {};
    paymentTerms.forEach((term) => {
      const percent = updatedPercentages[term] || 0;
      updatedAmounts[term] = (percent / 100) * rateCardPrice;
    });

    setAmounts(updatedAmounts);
  };

  const getDecimalPlaces = (num) => {
    const parts = num?.toString().split(".");
    return parts[1] ? parts[1].length : 0;
  };
  const handleRemoveAvailability = (index) => {
    removeDaysSelectedByIndex(index);
    const updated = availabilityRanges.filter((_, i) => i !== index);
    // Clear all dynamic form fields
    const fieldsToReset = [];
    availabilityRanges.forEach((_, i) => {
      fieldsToReset.push(`startAndEndDate_${i}`, `quantity_${i}`);
    });
    form.resetFields(fieldsToReset);
    setAvailabilityRanges(updated);
    const updatedFields = {};
    updated.forEach((item, i) => {
      updatedFields[`startAndEndDate_${i}`] = item.value;
      updatedFields[`quantity_${i}`] = item.unitQty;
    });
    form.setFieldsValue(updatedFields);
  };
  const paymentTermDays = {
    WEEKLY: 7,
    MONTHLY: 30,
    QUARTERLY: 60,
  };

  const tableColumns = [
    {
      title: "Term",
      dataIndex: "term",
      key: "term",
      width: 250,

      render: (value, record, index) => {
        const isFirstRow = index === 0;

        // Always read percentage from table state
        const upfrontPercentage = parseFloat(paymentTermsData[0]?.percentage);

        const hasUpfrontPercentage =
          !isNaN(upfrontPercentage) &&
          upfrontPercentage > 0 &&
          upfrontPercentage < 100;

        const firstTerm = paymentTermsData[0]?.term;

        const secondRowEnabled =
          firstTerm === "UPFRONT" && hasUpfrontPercentage;

        return (
          <FloatingSelect
            className="billboard-select-feild width-style-100 "
            label={<>Select payment term</>}
            value={record.term || undefined}
            disabled={
              !rateCardPrice && billBoardText !== "Edit Product Details"
            }
            options={
              isFirstRow
                ? [
                    {
                      id: "UPFRONT",
                      name: "Upfront",
                    },
                    {
                      id: "WEEKLY",
                      name: "Weekly",
                    },
                    {
                      id: "MONTHLY",
                      name: "Monthly",
                    },
                    {
                      id: "QUARTERLY",
                      name: "Quarterly",
                    },
                  ]
                : [
                    {
                      id: "WEEKLY",
                      name: "Weekly",
                    },
                    {
                      id: "MONTHLY",
                      name: "Monthly",
                    },
                    {
                      id: "QUARTERLY",
                      name: "Quarterly",
                    },
                  ]
            }
            onChange={(_e, selectedValue) => {
              // =====================================================
              // CLEAR / CLOSE BUTTON
              // =====================================================
              if (!selectedValue) {
                // If X is clicked on SECOND ROW
                if (index === 1) {
                  setPaymentTermsData((prev) => {
                    if (!prev.length) {
                      return prev;
                    }

                    // Keep only first row and make it 100%
                    return [
                      {
                        ...prev[0],
                        percentage: 100,
                      },
                    ];
                  });

                  // Update form value
                  form.setFieldsValue({
                    percentage_0: 100,
                    percentage_1: undefined,
                  });

                  return;
                }

                return;
              }

              const selectedTerm = selectedValue?.value;

              if (!selectedTerm) {
                return;
              }

              const days = paymentTermDays[selectedTerm] || 0;

              // =====================================================
              // FIRST ROW
              // =====================================================
              if (index === 0) {
                // -------------------------------------------------
                // UPFRONT
                // -------------------------------------------------
                if (selectedTerm === "Upfront") {
                  form.setFieldsValue({
                    percentage_0: 0,
                    percentage_1: undefined,
                  });

                  setPaymentTermsData((prev) => [
                    {
                      ...(prev[0] || {}),
                      key: "1",
                      term: "Upfront",
                      percentage: 0,
                      days: 0,
                    },
                  ]);

                  return;
                }

                // -------------------------------------------------
                // WEEKLY / MONTHLY / QUARTERLY
                // -------------------------------------------------
                form.setFieldsValue({
                  percentage_0: 100,
                  percentage_1: undefined,
                });

                setPaymentTermsData([
                  {
                    ...(paymentTermsData[0] || {}),
                    key: "1",
                    term: selectedTerm,
                    percentage: 100,
                    days: days,
                  },
                ]);

                return;
              }

              // =====================================================
              // SECOND ROW
              // =====================================================
              if (index === 1) {
                const upfrontPercentage =
                  parseFloat(paymentTermsData[0]?.percentage) || 0;

                const remainingPercentage = Math.max(
                  0,
                  100 - upfrontPercentage,
                );

                setPaymentTermsData((prev) => {
                  const updatedData = [...prev];

                  updatedData[1] = {
                    ...(updatedData[1] || {}),
                    key: "2",
                    term: selectedTerm,
                    percentage: remainingPercentage,
                    days: days,
                  };

                  return updatedData;
                });

                form.setFieldsValue({
                  percentage_1: remainingPercentage,
                });

                return;
              }
            }}
            customStyles={floatingSelectStyles}
          />
        );
      },
    },

    {
      title: "Percentage (%)",
      dataIndex: "percentage",
      key: "percentage",
      width: 250,

      render: (value, record, index) => {
        const isUpfront = record.term === "Upfront";
        return (
          <Form.Item className="payment-term-form">
            <IconFloatingInput
              innerClassName="inner-payment-term"
              className="payment-term"
              addon={false}
              type="text"
              value={record.percentage ?? 0}
              // label={<>Percentage</>}
              disabled={isUpfront ? false : true}
              onChange={(e) => {
                const rawValue = e?.target?.value ?? "";

                if (rawValue === "") {
                  if (index === 0 && isUpfront) {
                    setPaymentTermsData((prev) => [
                      {
                        ...prev[0],
                        percentage: 0,
                      },
                    ]);
                  }
                  return;
                }

                let percentage = parseInt(rawValue, 10);

                if (isNaN(percentage)) {
                  return;
                }

                percentage = Math.max(0, Math.min(100, percentage));

                // First row - UPFRONT
                if (index === 0 && isUpfront) {
                  const remainingPercentage = 100 - percentage;

                  setPaymentTermsData((prev) => {
                    const updatedData = [...prev];

                    updatedData[0] = {
                      ...updatedData[0],
                      percentage,
                    };

                    if (percentage > 0 && percentage < 100) {
                      updatedData[1] = {
                        ...(updatedData[1] || {}),
                        key: "2",
                        term: updatedData[1]?.term || "",
                        percentage: remainingPercentage,
                        days: updatedData[1]?.days || 0,
                      };

                      return updatedData;
                    }

                    return [updatedData[0]];
                  });

                  return;
                }
              }}
            />
          </Form.Item>
        );
      },
    },

    // =========================================================
    // AMOUNT
    // =========================================================
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      align: "right",
      width: 400,

      render: (value, record) => {
        const percentage = parseFloat(record.percentage) || 0;

        const rateCard =
          parseFloat(form.getFieldValue("rateCard")) ||
          parseFloat(rateCardPrice) ||
          0;

        const amount = (rateCard * percentage) / 100;

        return (
          <Text className="info-message">{formatToUSCurrency(amount)}</Text>
        );
      },
    },
  ];

  useEffect(() => {
    if (product) {
      form.setFieldsValue({
        ...cpmNames.reduce(
          (acc, name) => ({
            ...acc,
            [name]:
              product?.[name] === "null" ||
              product?.[name] === "" ||
              product?.[name] === "undefined"
                ? ""
                : product?.[name],
          }),
          {},
        ),
      });
      setIsVariable(product?.fix === "Variable");
      setAmpBills(product?.billingYes !== "yes");
      setAmpServices(product?.servicingYes !== "yes");
      setSelectedFile(product?.image?.[0] || null);
      setFiles(product?.image);
    }
  }, [product]);

  const handleProductTypes = useCallback((value) => {
    form.setFieldsValue({ type: null });
    const selectedChannel = productChannelsList?.find(
      (product) => product.id === value,
    );
    if (selectedChannel) {
      const mapping = {
        Digital: "Digital",
        "Digital/Static": "Digital/Static",
        Media: "Media",
        Static: "Static",
      };
      const productTypeList = Object.entries(mapping)
        ?.filter(([key]) => selectedChannel[key] === 1)
        ?.map(([, label]) => label);
      setProductTypeList(productTypeList);
    }
  });
  // Converting the dates into array helper
  const getDateValues = (dateField) => {
    if (Array.isArray(dateField)) {
      return dateField;
    }

    return dateField ? [dateField] : [];
  };
  useEffect(() => {
    if (product) {
      handleProductTypes(
        product?.channel_ids?.[0] || product?.channel_ids?.[0] !== ""
          ? product?.channel_ids?.[0]
          : null,
      );
      setIsSponsored(product?.sponsor_yes_no || false);
      setSelectedProductType(product?.type);
      if (product?.area) {
        setSelectedDmaChanged(true);
      }
      // implemented single dates to multi slot dates render in components
      const fromDates = getDateValues(product?.from_date);
      const toDates = getDateValues(product?.to_date);
      const quantity = product?.unitQty || [];
      const dynamicRanges = fromDates?.map((from, index) => {
        const startDate = dayjs(Number(from?.$date?.$numberLong));
        const endDate = dayjs(Number(toDates?.[index]?.$date?.$numberLong));
        return {
          id: index + 1,
          value: [startDate, endDate],
          unitQty: quantity[index] || "",
        };
      });
      setAvailabilityRanges(dynamicRanges);
      const dynamicDays = {};
      const dynamicFormValues = {};
      dynamicRanges?.forEach((range, index) => {
        dynamicDays[index] =
          range?.value?.[1]?.diff(range?.value?.[0], "day") + 1;

        dynamicFormValues[`startAndEndDate_${index}`] = range?.value;
        dynamicFormValues[`quantity_${index}`] = range?.unitQty;
      });
      setNoOfDaysSelected(dynamicDays);
      const paymentData = [];

      if (
        product?.stripe_percent != null &&
        Number(product?.stripe_percent) > 0
      ) {
        paymentData.push({
          key: String(paymentData.length + 1),
          term: "Upfront",
          percentage: product.stripe_percent,
          days: 0,
        });
      }

      if (
        product?.net_7_percent != null &&
        Number(product?.net_7_percent) > 0
      ) {
        paymentData.push({
          key: String(paymentData.length + 1),
          term: "Weekly",
          percentage: product.net_7_percent,
          days: 7,
        });
      }

      if (
        product?.net_30_percent != null &&
        Number(product?.net_30_percent) > 0
      ) {
        paymentData.push({
          key: String(paymentData.length + 1),
          term: "Monthly",
          percentage: product.net_30_percent,
          days: 30,
        });
      }

      if (
        product?.net_90_percent != null &&
        Number(product?.net_90_percent) > 0
      ) {
        paymentData.push({
          key: String(paymentData.length + 1),
          term: "Quarterly",
          percentage: product.net_90_percent,
          days: 60,
        });
      }

      setPaymentTermsData(paymentData);

      form.setFieldsValue({
        ...dynamicFormValues,
        type: product?.type,
        "channel_ids[0]":
          product?.channel_ids?.[0] || product?.channel_ids?.[0] !== ""
            ? product?.channel_ids?.[0]
            : null,
        title: product?.title,
        address: product?.address,
        area: product?.city || product?.city !== "" ? product?.city : null,
        state: product?.state,
        zipcode: product?.zipcode,
        lat: product?.lat,
        lng: product?.lng,
        locationDesc: product?.locationDesc,
        imgdirection: product?.imgdirection,
        direction: product?.direction,
        lighting: product?.lighting === "" ? "no" : product?.lighting,
        network: product?.network ? product?.network : null,
        nationloc: product?.nationloc ? product?.nationloc : null,
        placement: product?.placement,
        genre: product?.genre,
        medium: product?.medium,
        product_newMedia: product?.product_newMedia,
        mediahhi:
          product?.mediahhi === "null" ||
          product?.mediahhi === "" ||
          product?.mediahhi === "undefined"
            ? ""
            : Number(product?.mediahhi?.replace(/,/g, "")),
        description:
          product?.description === "null" ||
          product?.description === "" ||
          product?.description === "undefined"
            ? ""
            : product?.description,
        daypart: product?.daypart,
        file_type: product?.file_type ? product?.file_type : null,
        spotLength: product?.spotLength,
        fliplength: product?.fliplength,
        ageloopLength: product?.ageloopLength,
        staticMotion: product?.staticMotion ? product?.staticMotion : null,
        sound: product?.sound ? product?.sound : null,
        length: product?.length,
        height: product?.height?.split(" ")?.[0],
        pixels: product?.height?.split(" ")?.[1] || "pixels",
        width: product?.width?.split(" ")?.[0],
        notes: product?.notes || "",
        rateCard: product?.rateCard,
        negotiatedCost: product?.negotiatedCost,
        productioncost: Number.isInteger(product?.productioncost)
          ? String(product.productioncost)
          : product?.productioncost,
        installCost: Number.isInteger(product?.installCost)
          ? String(product?.installCost)
          : product?.installCost,
        minimumdays: product?.minimumdays,
        tax_percentage:
          product?.tax_percentage === "null" ||
          product?.tax_percentage === "" ||
          product?.tax_percentage === "undefined"
            ? ""
            : product?.tax_percentage,
        fix: product?.fix || "Fixed",
        sponsor_yes_no: product?.sponsor_yes_no || false,
        unitQty: product?.unitQty || "",
        weekPeriod:
          product?.weekPeriod === "null" ||
          product?.weekPeriod === "" ||
          product?.weekPeriod === "undefined"
            ? "0.00"
            : Number(product?.weekPeriod)?.toFixed(2),
        vendor:
          product?.vendor ||
          `${JSON.parse(user).user.firstName} ${
            JSON.parse(user).user.lastName
          }`,
        sellerId:
          product?.sellerId === "null" ||
          product?.sellerId === "" ||
          product?.sellerId === "undefined"
            ? ""
            : product?.sellerId,
        city_name: product?.city_name,
        Description: product?.description,
        Comments: product?.Comments != "undefined" ? product?.Comments : "",
        billingYes: product?.billingYes ? product?.billingYes : "",
        billingNo: product?.billingNo || "No",
        servicingYes: product?.servicingYes ? product?.servicingYes : "No",
        servicingNo: product?.servicingNo ? product?.servicingNo : "No",
        audited: product?.audited || "No",
        cancellation_policy: product?.cancellation_policy,
        cancellation_terms: product?.cancellation_terms,
        firstImpression:
          product?.firstImpression === "null" ||
          product?.firstImpression === "undefined" ||
          product?.firstImpression === ""
            ? ""
            : product?.firstImpression,
        secondImpression:
          product?.secondImpression === "null" ||
          product?.secondImpression === "undefined" ||
          product?.secondImpression === ""
            ? ""
            : product?.secondImpression,
        thirdImpression:
          product?.thirdImpression === "null" ||
          product?.thirdImpression === "undefined" ||
          product?.thirdImpression === ""
            ? ""
            : product?.thirdImpression,
        forthImpression:
          product?.forthImpression === "null" ||
          product?.forthImpression === "undefined" ||
          product?.forthImpression === ""
            ? ""
            : product?.forthImpression,
        stripe_percent:
          paymentTermsData.find(
            (item) => item.term?.toUpperCase() === "UPFRONT",
          )?.percentage ?? 0,

        net_7_percent:
          paymentTermsData.find((item) => item.term?.toUpperCase() === "WEEKLY")
            ?.percentage ?? 0,

        net_30_percent:
          paymentTermsData.find(
            (item) => item.term?.toUpperCase() === "MONTHLY",
          )?.percentage ?? 0,

        net_90_percent:
          paymentTermsData.find(
            (item) => item.term?.toUpperCase() === "QUARTERLY",
          )?.percentage ?? 0,
      });
      // paymentTerms.forEach((term) => {
      //   PercentageCalculation(term, product?.[term]);
      // });
    } else {
      setDmaLocations([]);
      form.setFieldsValue({ default_image_type: "Default", audited: "No" });
    }
  }, [product]);

  useEffect(() => {
    dispatch(getChannelsFromProductType({ type: [] })).then(() => {
      if (id) {
        dispatch(getProductDetails(id));
      }
    });
  }, [id]);

  useEffect(() => {
    if (!id) {
      dispatch(RESET_PRODUCT());
      setSelectedProductType("Static");
      form.resetFields();
    }
  }, [id]);
  // Handling the adding the multiple slots
  const handleAddAvailability = () => {
    const lastRange = availabilityRanges[availabilityRanges.length - 1];
    const hasValidDates = lastRange?.value && lastRange.value.length === 2;
    const hasValidQuantity =
      selectedProductType !== "Digital" ||
      (lastRange?.unitQty && Number(lastRange.unitQty) > 0);
    if (!hasValidDates || !hasValidQuantity) {
      return;
    }
    setAvailabilityRanges((prev) => [
      ...prev,
      {
        id: Date.now(),
        value: null,
        unitQty: "",
      },
    ]);
  };
  const canAddAvailability = availabilityRanges.every((item) => {
    const hasValidDates = item?.value && item.value.length === 2;
    if (selectedProductType === "Digital") {
      return hasValidDates && item?.unitQty && Number(item.unitQty) > 0;
    }
    return hasValidDates;
  });

  // As per the index clearing the selected dates
  const removeDaysSelectedByIndex = (index) => {
    setNoOfDaysSelected((prev) => {
      const updated = { ...prev };
      delete updated[index];
      const reIndexed = {};
      Object.keys(updated).forEach((key) => {
        const currentKey = Number(key);
        reIndexed[currentKey > index ? currentKey - 1 : currentKey] =
          updated[key];
      });

      return reIndexed;
    });
  };
  // clearing the dates by index
  const clearDaysSelectedByIndex = (index) => {
    setNoOfDaysSelected((prev) => ({
      ...prev,
      [index]: 0,
    }));
  };
  // Checking the selected dates overlaping with the prev selected ranges
  const hasOverlappingRange = (selectedRange, currentIndex) => {
    if (!selectedRange?.[0] || !selectedRange?.[1]) {
      return false;
    }

    const selectedStart = selectedRange[0]?.startOf("day");
    const selectedEnd = selectedRange[1]?.endOf("day");

    return availabilityRanges?.some((range, rangeIndex) => {
      if (
        rangeIndex === currentIndex ||
        !range?.value?.[0] ||
        !range?.value?.[1]
      ) {
        return false;
      }

      const existingStart = range?.value[0]?.startOf("day");
      const existingEnd = range?.value[1]?.endOf("day");

      return !(selectedEnd < existingStart || selectedStart > existingEnd);
    });
  };

  useEffect(() => {
    if (!paymentTermsData?.length) return;

    const firstRow = paymentTermsData[0];

    const firstPercentage = parseFloat(firstRow?.percentage) || 0;

    const totalPercentage = paymentTermsData.reduce(
      (total, item) => total + (parseFloat(item?.percentage) || 0),
      0,
    );

    // Valid payment terms
    if (
      firstRow?.term &&
      totalPercentage === 100 &&
      !(
        firstRow.term === "Upfront" &&
        firstPercentage > 0 &&
        firstPercentage < 100 &&
        !paymentTermsData[1]?.term
      )
    ) {
      form.setFields([
        {
          name: "payment_terms_validation",
          errors: [],
        },
      ]);
    }
  }, [paymentTermsData, form]);
  return (
    <>
      <Row
        className="add-billboard-main-div"
        style={{
          maxHeight: isMobile ? "100%" : "44rem",
          padding: isMobile && "1rem",
        }}
      >
        <Form
          form={form}
          initialValues={{
            area: null,
            default_image_type: "Default",
            sponsor_yes_no: false,
            fix: "Variable",
            nationloc: "National",
            pixels: "pixels",
            unitQty: "",
            vendor:
              product?.vendor ||
              `${JSON.parse(user).user.firstName} ${
                JSON.parse(user).user.lastName
              }`,
            billingYes: "",
            billingNo: "no",
            servicingYes: "",
            servicingNo: "no",
            audited: "No",
            weekPeriod: "0.00",
            network: "No",
            stripe_percent: undefined,
            net_15_percent: undefined,
            net_30_percent: undefined,
            net_45_percent: undefined,
            net_60_percent: undefined,
            net_90_percent: undefined,
          }}
          onFinish={handleSaveDetails}
          style={{
            display: isMobile ? "block" : "contents",
            width: isMobile && "100%",
          }}
        >
          <Col style={{ width: isMobile ? "100%" : "38%" }}>
            <BillboardImageUploader
              initialSelectedFile={selectedFile}
              billboardFiles={files}
              fileInputRef={fileInputRef}
              setFiles={setFiles}
              setBinaryImages={setBinaryImages}
              id={id}
              isClone={isClone}
              product={product}
            />
          </Col>
          <Col
            style={{ width: isMobile ? "100%" : "60%" }}
            className={!isMobile && "add-billboard-scroll"}
          >
            <div>
              <p className="add-billboard-css add-billboard-design">
                BASIC DETAILS
              </p>

              <Row
                className="billboard-form-row"
                style={{ flexWrap: isMobile ? "wrap" : "nowrap" }}
              >
                <Col
                  className="billboard-form-column"
                  style={{ width: isMobile ? "100%" : "32%" }}
                >
                  <Form.Item name="channel_ids[0]">
                    <FloatingSelect
                      className="billboard-select-feild"
                      showSearch
                      filterOption={(input, option) =>
                        option?.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      disabled={product ? true : false}
                      label={<>{`Channels `}</>}
                      isChannels={true}
                      onChange={(_e, value) => {
                        if (!value) {
                          setProductTypeList([]);
                          setSelectedProductType("Static");
                          form.setFieldsValue({ type: null });
                          form.setFieldsValue({ title: "" });
                          return;
                        }
                        handleProductTypes(value?.value);
                        const locationDma = form.getFieldValue("area")
                          ? dmaLocations?.find(
                              (location) =>
                                location.value === form.getFieldValue("area"),
                            )
                          : undefined;
                        form.setFieldsValue({
                          title: [
                            value?.children,
                            locationDma
                              ? `${locationDma?.label} - ${locationDma?.state}`
                              : "",
                            formatDateRange(
                              form.getFieldValue("startAndEndDate"),
                            ),
                          ]
                            ?.filter(Boolean)
                            ?.join(" - "),
                        });
                      }}
                      options={productChannelsList?.map((channel) => ({
                        id: channel.id,
                        name: `${channel.channel_name} - ${channel.sub_channel_name}`,
                      }))}
                      customStyles={floatingSelectStyles}
                    />
                  </Form.Item>
                </Col>
                <Col
                  className="billboard-form-column"
                  style={{ width: isMobile ? "100%" : "32%" }}
                >
                  <Form.Item
                    name="type"
                    rules={[
                      {
                        required: true,
                        message: "Format Type is required!",
                      },
                    ]}
                  >
                    <FloatingSelect
                      className="billboard-select-feild"
                      label={
                        <>
                          {`Format Type `}
                          {star}
                        </>
                      }
                      disabled={product ? true : false}
                      value={selectedProductType}
                      options={productTypeList?.map((type, index) => ({
                        id: index,
                        name: type,
                      }))}
                      customStyles={floatingSelectStyles}
                      onChange={(_e, value) => {
                        const latest = value?.value || "Static";
                        const fieldsToReset = [];
                        availabilityRanges.forEach((_, index) => {
                          fieldsToReset.push(`startAndEndDate_${index}`);
                          if (
                            selectedProductType === "Digital" ||
                            latest === "Digital"
                          ) {
                            fieldsToReset.push(`quantity_${index}`);
                          }
                        });
                        form.resetFields(fieldsToReset);
                        setAvailabilityRanges([
                          {
                            id: 1,
                            value: null,
                            unitQty: "",
                          },
                        ]);
                        setNoOfDaysSelected({
                          0: 0,
                        });
                        setSelectedProductType(latest);
                      }}
                    />
                  </Form.Item>
                </Col>

                <Col
                  className="billboard-form-column"
                  style={{ width: isMobile ? "100%" : "32%" }}
                >
                  <Form.Item
                    name="title"
                    rules={[
                      {
                        required: true,
                        message: "Product Title is required!",
                      },
                    ]}
                  >
                    <FloatingInput
                      className="billboard-input-feild"
                      label={
                        <>
                          {`Product Title `}
                          {star}
                        </>
                      }
                      onChange={(e) => {
                        const title = e.target.value?.replace(/\s{2,}/g, " ");
                        form.setFieldsValue({ title: title });
                      }}
                      customStyles={floatingInputStyles}
                    ></FloatingInput>
                  </Form.Item>
                </Col>
              </Row>
              {/* </Form> */}
            </div>
            <div>
              <p className="add-billboard-css add-billboard-design">
                LOCATION DETAILS
              </p>

              <Row
                className="billboard-form-row"
                style={{ flexWrap: isMobile ? "wrap" : "nowrap" }}
              >
                <Col
                  className="billboard-form-column"
                  style={{ width: isMobile ? "100%" : "32%" }}
                >
                  <Form.Item
                    name="address"
                    rules={[
                      {
                        required: true,
                        message: "Street Address is required!",
                      },
                    ]}
                  >
                    <FloatingInput
                      className="billboard-input-feild"
                      label={
                        <>
                          {`Street Address `}
                          {star}
                        </>
                      }
                      customStyles={floatingInputStyles}
                    ></FloatingInput>
                  </Form.Item>
                </Col>
                <Col
                  className="billboard-form-column"
                  style={{ width: isMobile ? "100%" : "32%" }}
                >
                  <Form.Item
                    name="area"
                    rules={[
                      {
                        required: true,
                        message: "Dma is required!",
                      },
                    ]}
                  >
                    <FloatingSelect
                      showSearch
                      allowClear
                      className="billboard-select-feild"
                      onSearch={(val) => handleSearch(val)}
                      label={
                        <>
                          {`DMA `}
                          {star}
                        </>
                      }
                      loading={isLoadingLocation}
                      onChange={(_e, value) => {
                        if (!value) {
                          setDmaLocations([]);
                          form.setFieldsValue({
                            area: undefined,
                          });
                          return;
                        }
                        setSelectedDmaChanged(false);
                        const selectedDma = dmaLocations?.find(
                          (loc) => loc.value === value.value,
                        );
                        form.setFieldsValue({
                          title: [
                            getChannelsById(
                              form.getFieldValue("channel_ids[0]"),
                            ),
                            value ? `${selectedDma?.label}` : "",
                            formatDateRange(
                              form.getFieldValue("startAndEndDate"),
                            ),
                          ]
                            .filter(Boolean)
                            .join(" - "),
                        });

                        if (
                          selectedDma?.label === "Nationwide - Entire Country"
                        ) {
                          form.setFieldsValue({
                            address: selectedDma?.streetaddress,
                            state: selectedDma?.state,
                            zipcode: selectedDma?.pincode,
                            lat: selectedDma?.lat,
                            lng: selectedDma?.lng,
                          });
                        }
                      }}
                      optionFilterProp="label"
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? "")
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? "").toLowerCase())
                      }
                      isDma={true}
                      options={dmaLocations}
                      customStyles={floatingSelectStyles}
                    />
                  </Form.Item>
                </Col>
                <Col
                  className="billboard-form-column"
                  style={{ width: isMobile ? "100%" : "32%" }}
                >
                  <Form.Item
                    name="state"
                    rules={[
                      {
                        required: true,
                        message: "State is required!",
                      },
                    ]}
                  >
                    <FloatingInput
                      className="billboard-input-feild"
                      label={
                        <>
                          {`State `}
                          {star}
                        </>
                      }
                      customStyles={floatingInputStyles}
                    ></FloatingInput>
                  </Form.Item>
                </Col>
              </Row>
              <Row
                className="billboard-form-row"
                style={{ flexWrap: isMobile ? "wrap" : "nowrap" }}
              >
                <Col
                  className="billboard-form-column"
                  style={{ width: isMobile ? "100%" : "32%" }}
                >
                  <Form.Item
                    name="city_name"
                    rules={[
                      {
                        required: true,
                        message: "City is required!",
                      },
                    ]}
                  >
                    <FloatingInput
                      className="billboard-input-feild"
                      label={
                        <>
                          {`City `}
                          {star}
                        </>
                      }
                      customStyles={floatingInputStyles}
                    ></FloatingInput>
                  </Form.Item>
                </Col>
                <Col
                  className="billboard-form-column"
                  style={{ width: isMobile ? "100%" : "32%" }}
                >
                  <Form.Item
                    name="lat"
                    rules={[
                      {
                        required: true,
                        message: "Latitude is required!",
                      },
                      {
                        validator: (_, value) => {
                          const longitudeRegex =
                            /^(\+|-)?(?:90(?:(?:\.0{1,6})?)|(?:[0-9]|[1-8][0-9])(?:(?:\.[0-9]{1,6})?))$/;
                          if (!value || longitudeRegex.test(value)) {
                            return Promise.resolve();
                          }
                          return Promise.reject(new Error("Invalid Latitude"));
                        },
                      },
                    ]}
                  >
                    <FloatingInput
                      className="billboard-input-feild"
                      label={
                        <>
                          {`Latitude `}
                          {star}
                        </>
                      }
                      customStyles={floatingInputStyles}
                    ></FloatingInput>
                  </Form.Item>
                </Col>
                <Col
                  className="billboard-form-column"
                  style={{ width: isMobile ? "100%" : "32%" }}
                >
                  <Form.Item
                    name="lng"
                    rules={[
                      {
                        required: true,
                        message: "Longitude is required!",
                      },
                      {
                        validator: (_, value) => {
                          const longitudeRegex =
                            /^(\+|-)?(?:180(?:\.0{1,6})?|(?:[0-9]|[1-9][0-9]|1[0-7][0-9])(?:\.[0-9]{1,6})?)$/;
                          if (!value || longitudeRegex.test(value)) {
                            return Promise.resolve();
                          }
                          return Promise.reject(new Error("Invalid Longitude"));
                        },
                      },
                    ]}
                  >
                    <FloatingInput
                      className="billboard-input-feild"
                      label={
                        <>
                          {`Longitude `}
                          {star}
                        </>
                      }
                      customStyles={floatingInputStyles}
                    ></FloatingInput>
                  </Form.Item>
                </Col>
              </Row>
              <Row
                className="billboard-form-row"
                style={{ flexWrap: isMobile ? "wrap" : "nowrap" }}
              >
                <Col
                  className="billboard-form-column"
                  style={{ width: isMobile ? "100%" : "32%" }}
                >
                  <Form.Item
                    name="zipcode"
                    rules={[
                      {
                        required: true,
                        message: "Zip Code is required!",
                      },
                    ]}
                  >
                    <FloatingInput
                      className="billboard-input-feild"
                      label={
                        <>
                          {`ZIP Code `}
                          {star}
                        </>
                      }
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      inputMode="decimal"
                      min={0}
                      max={9999999999}
                      pattern="[0-9]*"
                      onKeyDown={(e) => {
                        if (["e", "E", "+", "-"].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      onChange={(e) => {
                        if (Number(e.target.value) > 9999999999)
                          return form.setFieldsValue({
                            zipcode: Number(form.getFieldValue("zipcode"))
                              ?.toString()
                              .slice(0, 10),
                          });
                      }}
                      customStyles={floatingInputStyles}
                    ></FloatingInput>
                  </Form.Item>
                </Col>
                <Col
                  className="billboard-form-column"
                  style={{ width: isMobile ? "100%" : "32%" }}
                >
                  <Form.Item
                    name="locationDesc"
                    rules={[
                      {
                        required: true,
                        message: "Location Description is required!",
                      },
                    ]}
                  >
                    <FloatingTextArea
                      customStyles={textAreaFloatingInputStyles}
                      label={
                        <>
                          {`Location Description `}
                          {star}
                        </>
                      }
                      className="billboard-input-feild billboard-text-area"
                    ></FloatingTextArea>
                  </Form.Item>
                </Col>
              </Row>
            </div>
            <div>
              <p className="add-billboard-css add-billboard-design">
                SPECIFICATIONS
              </p>

              <Row
                className="billboard-form-row"
                style={{ flexWrap: isMobile ? "wrap" : "nowrap" }}
              >
                <Col
                  className="billboard-form-column"
                  style={{ width: isMobile ? "100%" : "32%" }}
                >
                  <Form.Item
                    name="imgdirection"
                    rules={[
                      {
                        required: true,
                        message: "Product Direction is required!",
                      },
                    ]}
                  >
                    <FloatingSelect
                      className="billboard-select-feild"
                      label={
                        <>
                          {`Product Direction `}
                          {star}
                        </>
                      }
                      options={[
                        { id: 1, name: "Left Hand Read" },
                        { id: 2, name: "Right hand Read" },
                        { id: 3, name: "Not Applicable" },
                      ]}
                      customStyles={floatingSelectStyles}
                    />
                  </Form.Item>
                </Col>
                {selectedProductType?.toLocaleLowerCase() !== "media" && (
                  <Col
                    className="billboard-form-column"
                    style={{ width: isMobile ? "100%" : "32%" }}
                  >
                    <Form.Item
                      name="direction"
                      rules={[
                        {
                          required: true,
                          message: "Facing Direction is required!",
                        },
                      ]}
                    >
                      <FloatingInput
                        className="billboard-input-feild"
                        label={
                          <>
                            {`Facing Direction `}
                            {star}
                          </>
                        }
                        customStyles={floatingInputStyles}
                      ></FloatingInput>
                    </Form.Item>
                  </Col>
                )}
                {selectedProductType === "Static" && (
                  <Col
                    className="billboard-form-column"
                    style={{ width: isMobile ? "100%" : "32%" }}
                  >
                    <Form.Item
                      name="lighting"
                      rules={[
                        {
                          required: true,
                          message: "Illumination is required!",
                        },
                      ]}
                    >
                      <FloatingSelect
                        className="billboard-select-feild"
                        label={
                          <>
                            {`Illumination `}
                            {star}
                          </>
                        }
                        options={[
                          { id: 1, name: "Yes" },
                          { id: 2, name: "No" },
                        ]}
                        customStyles={floatingSelectStyles}
                      />
                    </Form.Item>
                  </Col>
                )}
              </Row>
              {selectedProductType === "Media" && (
                <Row
                  className="billboard-form-row"
                  style={{ flexWrap: isMobile ? "wrap" : "nowrap" }}
                >
                  <Col
                    className="billboard-form-column"
                    style={{ width: isMobile ? "100%" : "32%" }}
                  >
                    <Form.Item
                      name="medium"
                      rules={[
                        {
                          required: true,
                          message: "Medium is required!",
                        },
                      ]}
                    >
                      <FloatingInput
                        className="billboard-input-feild"
                        label={
                          <>
                            {`Medium `}
                            {star}
                          </>
                        }
                        customStyles={floatingInputStyles}
                      ></FloatingInput>
                    </Form.Item>
                  </Col>

                  <Col
                    className="billboard-form-column"
                    style={{ width: isMobile ? "100%" : "32%" }}
                  >
                    <Form.Item
                      name="product_newMedia"
                      rules={[
                        {
                          required: true,
                          message: "Product is required!",
                        },
                      ]}
                    >
                      <FloatingInput
                        className="billboard-input-feild"
                        label={
                          <>
                            {`Product `}
                            {star}
                          </>
                        }
                        customStyles={floatingInputStyles}
                      ></FloatingInput>
                    </Form.Item>
                  </Col>
                </Row>
              )}

              {selectedProductType === "Media" && (
                <Row
                  className="billboard-form-row"
                  style={{ flexWrap: isMobile ? "wrap" : "nowrap" }}
                >
                  <Col
                    className="billboard-form-column"
                    style={{ width: isMobile ? "100%" : "32%" }}
                  >
                    <Form.Item
                      name="network"
                      rules={[
                        {
                          required: true,
                          message: "Network is required!",
                        },
                      ]}
                    >
                      <FloatingSelect
                        className="billboard-select-feild"
                        label={
                          <>
                            {`Network `}
                            {star}
                          </>
                        }
                        options={[
                          { id: "yes", name: "Yes" },
                          { id: "no", name: "No" },
                        ]}
                        customStyles={floatingSelectStyles}
                      />
                    </Form.Item>
                  </Col>
                  <Col
                    className="billboard-form-column"
                    style={{ width: isMobile ? "100%" : "32%" }}
                  >
                    <Form.Item
                      name="nationloc"
                      rules={[
                        {
                          required: true,
                          message: "National/Local is required!",
                        },
                      ]}
                    >
                      <FloatingSelect
                        className="billboard-select-feild"
                        label={
                          <>
                            {`National/Local `}
                            {star}
                          </>
                        }
                        options={[
                          { id: "national", name: "National" },
                          { id: "local", name: "Local" },
                        ]}
                        customStyles={floatingSelectStyles}
                      />
                    </Form.Item>
                  </Col>
                  <Col
                    className="billboard-form-column"
                    style={{ width: isMobile ? "100%" : "32%" }}
                  >
                    <Form.Item
                      name="placement"
                      rules={[
                        {
                          required: true,
                          message: "Ad Type is required!",
                        },
                      ]}
                    >
                      <FloatingInput
                        className="billboard-input-feild"
                        label={
                          <>
                            {`Ad Type `}
                            {star}
                          </>
                        }
                        customStyles={floatingInputStyles}
                      ></FloatingInput>
                    </Form.Item>
                  </Col>
                </Row>
              )}

              {selectedProductType === "Media" && (
                <Row
                  className="billboard-form-row"
                  style={{ flexWrap: isMobile ? "wrap" : "nowrap" }}
                >
                  <Col
                    className="billboard-form-column"
                    style={{ width: isMobile ? "100%" : "32%" }}
                  >
                    <Form.Item
                      name="genre"
                      rules={[
                        {
                          required: true,
                          message: "Genre is required!",
                        },
                      ]}
                    >
                      <FloatingInput
                        className="billboard-input-feild"
                        label={
                          <>
                            {`Genre `}
                            {star}
                          </>
                        }
                        customStyles={floatingInputStyles}
                      ></FloatingInput>
                    </Form.Item>
                  </Col>

                  <Col
                    className="billboard-form-column"
                    style={{ width: isMobile ? "100%" : "32%" }}
                  >
                    <Form.Item
                      name="daypart"
                      rules={[
                        {
                          required: true,
                          message: "Day Part is required!",
                        },
                      ]}
                    >
                      <FloatingInput
                        className="billboard-input-feild"
                        label={
                          <>
                            {"Day Part "}
                            {star}
                          </>
                        }
                        customStyles={floatingInputStyles}
                      ></FloatingInput>
                    </Form.Item>
                  </Col>

                  <Col
                    className="billboard-form-column"
                    style={{ width: isMobile ? "100%" : "32%" }}
                  >
                    <Form.Item
                      name="file_type"
                      rules={[
                        {
                          required: true,
                          message: "File Type is required!",
                        },
                      ]}
                    >
                      <FloatingSelect
                        className="billboard-select-feild"
                        label={
                          <>
                            {`File type `}
                            {star}
                          </>
                        }
                        options={[
                          { id: 1, name: "MP3" },
                          { id: 2, name: "MP4" },
                          { id: 3, name: "Jpeg" },
                        ]}
                        customStyles={floatingSelectStyles}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              )}
              <Row
                className="billboard-form-row"
                style={{ flexWrap: isMobile ? "wrap" : "nowrap" }}
              >
                {selectedProductType !== "" &&
                  selectedProductType !== "Static" && (
                    <Col
                      className="billboard-form-column"
                      style={{ width: isMobile ? "100%" : "32%" }}
                    >
                      <Form.Item
                        name={
                          selectedProductType === "Digital" ||
                          selectedProductType === "Media"
                            ? "spotLength"
                            : selectedProductType === "Digital/Static"
                              ? "fliplength"
                              : ""
                        }
                        rules={[
                          {
                            required: true,
                            message: `${
                              selectedProductType === "Digital" ||
                              selectedProductType === "Media"
                                ? "spot length"
                                : selectedProductType === "Digital/Static"
                                  ? "flip length"
                                  : ""
                            } is required!`,
                          },
                        ]}
                      >
                        <FloatingInput
                          className="billboard-input-feild"
                          label={
                            <>
                              {selectedProductType === "Digital/Static"
                                ? "Flip Length "
                                : `Spot Length `}
                              {star}
                            </>
                          }
                          inputMode="decimal"
                          pattern="^[0-9:]*$"
                          onKeyDown={(e) => {
                            const allowedKeys = [
                              "0",
                              "1",
                              "2",
                              "3",
                              "4",
                              "5",
                              "6",
                              "7",
                              "8",
                              "9",
                              ":",
                              "Backspace",
                              "Delete",
                              "ArrowLeft",
                              "ArrowRight",
                              "Tab",
                            ];
                            if (!allowedKeys.includes(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          customStyles={floatingInputStyles}
                        ></FloatingInput>
                      </Form.Item>
                    </Col>
                  )}
                {selectedProductType !== "" &&
                  selectedProductType !== "Static" && (
                    <Col
                      className="billboard-form-column"
                      style={{ width: isMobile ? "100%" : "32%" }}
                    >
                      <Form.Item
                        name="ageloopLength"
                        rules={[
                          {
                            required: true,
                            message: "Loop Length is required!",
                          },
                        ]}
                      >
                        <FloatingInput
                          className="billboard-input-feild"
                          label={
                            <>
                              {selectedProductType === "Media"
                                ? "Break / Loop Length "
                                : `Loop Length `}
                              {star}
                            </>
                          }
                          type="number"
                          onWheel={(e) => e.target.blur()}
                          inputMode="decimal"
                          pattern="^[0-9:]*$"
                          onKeyDown={(e) => {
                            const allowedKeys = [
                              "0",
                              "1",
                              "2",
                              "3",
                              "4",
                              "5",
                              "6",
                              "7",
                              "8",
                              "9",
                              ":",
                              "Backspace",
                              "Delete",
                              "ArrowLeft",
                              "ArrowRight",
                              "Tab",
                            ];
                            if (!allowedKeys.includes(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          customStyles={floatingInputStyles}
                        ></FloatingInput>
                      </Form.Item>
                    </Col>
                  )}
                {selectedProductType === "Media" && (
                  <Col
                    className="billboard-form-column"
                    style={{ width: isMobile ? "100%" : "32%" }}
                  >
                    <Form.Item
                      name="staticMotion"
                      rules={[
                        {
                          required: true,
                          message: "Static or Motion is required!",
                        },
                      ]}
                    >
                      <FloatingSelect
                        className="billboard-select-feild"
                        label={
                          <>
                            {`Static or Motion `}
                            {star}
                          </>
                        }
                        options={[
                          { id: 1, name: "Static" },
                          { id: 2, name: "Motion" },
                        ]}
                        customStyles={floatingSelectStyles}
                      />
                    </Form.Item>
                  </Col>
                )}
              </Row>
              <Row
                className="billboard-form-row"
                style={{ flexWrap: isMobile ? "wrap" : "nowrap" }}
              >
                <Col
                  className="billboard-form-column"
                  style={{ width: isMobile ? "100%" : "32%" }}
                >
                  {selectedProductType === "Media" && (
                    <Row className="billboard-row-css">
                      <Form.Item
                        style={{ width: "100%" }}
                        name="sound"
                        rules={[
                          {
                            required: true,
                            message: "Sound is required!",
                          },
                        ]}
                      >
                        <FloatingSelect
                          className="billboard-select-feild"
                          label={
                            <>
                              {`Sound `}
                              {star}
                            </>
                          }
                          options={[
                            { id: 1, name: "Yes" },
                            { id: 2, name: "No" },
                          ]}
                          customStyles={floatingSelectStyles}
                        />
                      </Form.Item>
                    </Row>
                  )}
                  {selectedProductType === "Media" && (
                    <Row className="billboard-row-css">
                      <Form.Item
                        style={{ width: "100%" }}
                        name="length"
                        rules={[
                          {
                            required: true,
                            message: "Length is required!",
                          },
                        ]}
                      >
                        <FloatingInput
                          className="billboard-input-feild"
                          type="number"
                          onWheel={(e) => e.target.blur()}
                          inputMode="decimal"
                          pattern="[0-9]*"
                          onKeyDown={(e) => {
                            if (["e", "E", "+", "-"].includes(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          label={
                            <>
                              {`Length `}
                              {star}
                            </>
                          }
                          customStyles={floatingInputStyles}
                        ></FloatingInput>
                      </Form.Item>
                    </Row>
                  )}
                  {selectedProductType !== "Media" && (
                    <Row
                      className="billboard-row-css"
                      style={{
                        flexFlow: "nowrap",
                      }}
                    >
                      <Col className="billboard-form-child-column">
                        <Form.Item
                          name="height"
                          rules={[
                            {
                              required: true,
                              message: "Height is required!",
                            },
                          ]}
                        >
                          <FloatingInput
                            className="billboard-input-feild"
                            type="number"
                            inputMode="decimal"
                            onWheel={(e) => e.target.blur()}
                            pattern="[0-9]*"
                            onKeyDown={(e) => {
                              if (["e", "E", "+", "-"].includes(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            label={
                              <>
                                {`Height `}
                                {star}
                              </>
                            }
                            customStyles={floatingInputStyles}
                          ></FloatingInput>
                        </Form.Item>
                      </Col>
                      <Col className="billboard-form-child-column">
                        <Form.Item name="pixels">
                          <FloatingSelect
                            isChannels={true}
                            className="billboard-select-feild"
                            label={<>{`Sizes`}</>}
                            options={[
                              { id: "pixels", name: "pixels" },
                              { id: "feet", name: "feet" },
                              { id: "LineInches", name: "Line Inches" },
                            ]}
                            customStyles={floatingSelectStyles}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  )}
                  {selectedProductType !== "Media" && (
                    <Row className="billboard-row-css">
                      <Col className="billboard-form-child-column">
                        <Form.Item
                          name="width"
                          rules={[
                            {
                              required: true,
                              message: "Width is required!",
                            },
                          ]}
                        >
                          <FloatingInput
                            className="billboard-input-feild"
                            type="number"
                            onWheel={(e) => e.target.blur()}
                            inputMode="decimal"
                            pattern="[0-9]*"
                            onKeyDown={(e) => {
                              if (["e", "E", "+", "-"].includes(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            label={
                              <>
                                {`Width `}
                                {star}
                              </>
                            }
                            customStyles={floatingInputStyles}
                          ></FloatingInput>
                        </Form.Item>
                      </Col>
                    </Row>
                  )}
                </Col>
                <Col style={{ width: isMobile ? "100%" : "65.5%" }}>
                  <Form.Item
                    name="notes"
                    rules={[
                      {
                        required: true,
                        message: "Restrictions is required!",
                      },
                    ]}
                  >
                    <FloatingTextArea
                      customStyles={textAreaFloatingInputStyles}
                      label={
                        <>
                          {`Restrictions `}
                          {star}
                        </>
                      }
                      className="billboard-input-feild billboard-text-area"
                    ></FloatingTextArea>
                  </Form.Item>
                </Col>
              </Row>
            </div>
            <div>
              <p className="add-billboard-css add-billboard-design">
                PRICING & AVAILABILITY
              </p>
              <Row
                className="billboard-form-row"
                style={{ flexWrap: isMobile ? "wrap" : "nowrap" }}
              >
                <Col
                  className="billboard-form-column"
                  style={{ width: isMobile ? "100%" : "32%" }}
                >
                  <Form.Item
                    name="rateCard"
                    rules={[
                      {
                        required: true,
                        message: "4-Week Price (Net Cost) is required!",
                      },
                    ]}
                  >
                    <IconFloatingInput
                      className="icon-input-feild"
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      label={
                        <>
                          {`4-Week Price (Net Cost) `}
                          {star}
                        </>
                      }
                      inputMode="decimal"
                      pattern="[0-9]*"
                      onKeyDown={(e) => {
                        if (["e", "E", "+", "-"].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      onChange={(e) => {
                        const rateCardValue = e.target.value;
                        setRateCardPrice(rateCardValue);
                        const updatedFields = {};
                        impressionNames.forEach((impressionName, index) => {
                          const existingValue =
                            form.getFieldValue(impressionName);
                          if (existingValue) {
                            if (rateCardValue) {
                              const cpmValue = cpmCalculation(
                                existingValue,
                                rateCardValue,
                              );
                              updatedFields[cpmNames[index]] =
                                cpmValue === ""
                                  ? ""
                                  : `${cpmValue?.toFixed(2)}`;
                            } else {
                              const cpmValue = cpmCalculation(existingValue, 0);
                              updatedFields[cpmNames[index]] =
                                cpmValue === ""
                                  ? ""
                                  : `${cpmValue?.toFixed(2)}`;
                            }
                          }
                          form.setFieldsValue(updatedFields);
                        });
                      }}
                      customStyles={iconFloatingInputStyles}
                    ></IconFloatingInput>
                  </Form.Item>
                </Col>
                <Col
                  className="billboard-form-column"
                  style={{ width: isMobile ? "100%" : "32%" }}
                >
                  <Form.Item
                    name="negotiatedCost"
                    rules={[
                      {
                        required: true,
                        message: "4-Week Negotiated Cost is required!",
                      },
                    ]}
                  >
                    <IconFloatingInput
                      className="icon-input-feild"
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      inputMode="decimal"
                      pattern="[0-9]*"
                      onKeyDown={(e) => {
                        if (["e", "E", "+", "-"].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      label={
                        <>
                          {`4-Week Negotiated Cost `}
                          {star}
                        </>
                      }
                      customStyles={iconFloatingInputStyles}
                    ></IconFloatingInput>
                  </Form.Item>
                </Col>
                <Col
                  className="billboard-form-column"
                  style={{ width: isMobile ? "100%" : "32%" }}
                >
                  <Form.Item
                    name="productioncost"
                    rules={[
                      {
                        required: true,
                        message: "Production Cost is required!",
                      },
                    ]}
                  >
                    <IconFloatingInput
                      className="icon-input-feild"
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      inputMode="decimal"
                      pattern="[0-9]*"
                      onKeyDown={(e) => {
                        if (["e", "E", "+", "-"].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      label={
                        <>
                          {`Production Cost `}
                          {star}
                        </>
                      }
                      customStyles={iconFloatingInputStyles}
                    ></IconFloatingInput>
                  </Form.Item>
                </Col>
              </Row>
              <Row
                className="billboard-form-row"
                style={{ flexWrap: isMobile ? "wrap" : "nowrap" }}
              >
                <Col
                  className="billboard-form-column"
                  style={{ width: isMobile ? "100%" : "32%" }}
                >
                  <Form.Item
                    name="installCost"
                    rules={[
                      {
                        required: true,
                        message: "Install Cost is required!",
                      },
                    ]}
                  >
                    <IconFloatingInput
                      className="icon-input-feild"
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      inputMode="decimal"
                      pattern="[0-9]*"
                      onKeyDown={(e) => {
                        if (["e", "E", "+", "-"].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      label={
                        <>
                          {`Install Cost `}
                          {star}
                        </>
                      }
                      customStyles={iconFloatingInputStyles}
                    ></IconFloatingInput>
                  </Form.Item>
                </Col>
                <Col
                  className="billboard-form-column"
                  style={{ width: isMobile ? "100%" : "32%" }}
                >
                  <Form.Item
                    name="minimumdays"
                    rules={[
                      {
                        required: true,
                        message: "Minimum Days is required!",
                      },
                    ]}
                  >
                    <FloatingInput
                      className="billboard-input-feild"
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      inputMode="decimal"
                      pattern="[0-9]*"
                      onKeyDown={(e) => {
                        if (["e", "E", "+", "-"].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      label={
                        <>
                          {`Minimum Days `}
                          {star}
                        </>
                      }
                      customStyles={floatingInputStyles}
                    ></FloatingInput>
                  </Form.Item>
                </Col>
              </Row>
              <Row
                className=" new-calendar-slots-row"
                style={{ flexWrap: isMobile ? "wrap" : "nowrap" }}
              >
                <Text className="add-billboard-css add-billboard-design availability-ranges-text">
                  Availability Dates{" "}
                </Text>

                <Text className="multiple-slot-description">
                  Add multiple available date ranges for this product.
                </Text>
                <Col className="multiple-slot-combo-col">
                  {availabilityRanges?.map((item, index) => (
                    <React.Fragment key={item?.id}>
                      <Form.Item
                        name={`startAndEndDate_${index}`}
                        rules={[
                          {
                            required: true,
                            message: "Start And End Date is required!",
                          },
                        ]}
                        className={`seller-multiple-slot-form-item ${
                          availabilityRanges.length > 1 && !item?.value
                            ? "range-picker-wrapper"
                            : ""
                        }`}
                      >
                        <RangePicker
                          placeholder={["Start and End Date*", ""]}
                          className="billboard-datepicker"
                          classNames={{
                            popup: {
                              root: "single-calendar",
                            },
                          }}
                          suffixIcon={
                            <CalenderIcon style={{ cursor: "pointer" }} />
                          }
                          value={item?.value}
                          rootClassName={
                            availabilityRanges.length > 1 && !item?.value
                              ? "show-clear-icon"
                              : ""
                          }
                          onChange={(e) => {
                            if (!e) {
                              clearDaysSelectedByIndex(index);
                              const updated = [...availabilityRanges];
                              updated[index] = {
                                ...updated[index],
                                value: null,
                                unitQty:
                                  selectedProductType === "Digital"
                                    ? ""
                                    : updated[index].unitQty,
                              };
                              setAvailabilityRanges(updated);
                              form.setFieldsValue({
                                [`startAndEndDate_${index}`]: null,
                                ...(selectedProductType === "Digital" && {
                                  [`quantity_${index}`]: undefined,
                                }),
                              });

                              return;
                            }
                            if (hasOverlappingRange(e, index)) {
                              // handling the duplicate warning message help of content and key
                              message.warning({
                                content:
                                  "Selected date range overlaps with an existing availability range.",
                                key: "overlapping-range",
                              });

                              form.setFieldsValue({
                                [`startAndEndDate_${index}`]: null,
                              });

                              return;
                            }

                            // update picker value
                            const updated = [...availabilityRanges];
                            updated[index].value = e;
                            setAvailabilityRanges(updated);
                            const locationDma = form.getFieldValue("area")
                              ? dmaLocations?.find(
                                  (location) =>
                                    location.value ===
                                    form.getFieldValue("area"),
                                )
                              : undefined;
                            const dates = e;
                            const daysDifference =
                              dates?.[1]?.diff(dates?.[0], "day") + 1;
                            form.setFieldsValue({
                              [`startAndEndDate_${index}`]: e,
                              weekPeriod: (daysDifference / 28)?.toFixed(2),
                            });
                            setNoOfDaysSelected((prev) => ({
                              ...prev,
                              [index]: daysDifference,
                            }));
                            const updatedFields = {};
                            if (dates) {
                              impressionNames.forEach(
                                (impressionName, index) => {
                                  if (
                                    form.getFieldValue("rateCard") &&
                                    (form.getFieldValue(impressionName) !==
                                      "" ||
                                      form.getFieldValue(impressionName) !== 0)
                                  ) {
                                    const existingValue =
                                      form.getFieldValue(impressionName);
                                    if (existingValue) {
                                      const cpmValue = cpmCalculation(
                                        form.getFieldValue(impressionName),
                                        form.getFieldValue("rateCard"),
                                      );
                                      updatedFields[cpmNames[index]] =
                                        cpmValue === ""
                                          ? ""
                                          : `${cpmValue?.toFixed(2)}`;
                                    }
                                    form.setFieldsValue(updatedFields);
                                  }
                                },
                              );
                            } else {
                              impressionNames.forEach(
                                (impressionName, index) => {
                                  if (
                                    form.getFieldValue("rateCard") &&
                                    (form.getFieldValue(impressionName) !==
                                      "" ||
                                      form.getFieldValue(impressionName) !== 0)
                                  ) {
                                    const cpmValue = cpmCalculation(
                                      form.getFieldValue(impressionName),
                                      form.getFieldValue("rateCard"),
                                    );
                                    updatedFields[cpmNames[index]] =
                                      cpmValue === ""
                                        ? ""
                                        : `${cpmValue?.toFixed(2)}`;
                                    form.setFieldsValue(updatedFields);
                                  }
                                },
                              );
                            }

                            form.setFieldsValue({
                              title: [
                                getChannelsById(
                                  form.getFieldValue("channel_ids[0]"),
                                ),
                                locationDma
                                  ? `${locationDma?.label} - ${locationDma?.state}`
                                  : "",
                                formatDateRange(e),
                              ]
                                ?.filter(Boolean)
                                ?.join(" - "),
                            });
                          }}
                          disabledDate={(current) => {
                            const dma = dmaLocations?.find(
                              (location) =>
                                location.value === form.getFieldValue("area"),
                            );
                            const nowUTC = moment().utc();
                            const nowInSelectedTZ = nowUTC
                              .tz(
                                product
                                  ? dma?.timeZone
                                    ? dma?.timeZone
                                    : product?.area_time_zone_type
                                  : dma?.timeZone,
                              )
                              ?.startOf("day");
                            // Disable previous selected ranges
                            const isDateAlreadySelected =
                              availabilityRanges?.some((range, rangeIndex) => {
                                // ignore current picker
                                if (rangeIndex === index) {
                                  return false;
                                }

                                if (!range?.value) {
                                  return false;
                                }

                                const start = range?.value[0];
                                const end = range?.value[1];

                                return (
                                  current &&
                                  current >= start?.startOf("day") &&
                                  current <= end?.endOf("day")
                                );
                              });
                            return (
                              (current &&
                                current?.isBefore(nowInSelectedTZ, "day")) ||
                              isDateAlreadySelected
                            );
                          }}
                          disabled={!selectedArea}
                        />

                        <span>{` No.of Days Selected : ${
                          noOfDaysSelected[index] > 0
                            ? noOfDaysSelected[index]
                            : 0
                        } Days`}</span>
                      </Form.Item>
                      {selectedProductType === "Digital" && (
                        <Form.Item
                          name={`quantity_${index}`}
                          rules={[
                            {
                              required: true,
                              message: "Quantity is required!",
                            },
                          ]}
                          className={`seller-multi-slot-quantity-field ${
                            availabilityRanges.length > 1 &&
                            item?.value &&
                            item?.unitQty
                              ? "with-delete-icon"
                              : ""
                          }`}
                        >
                          <FloatingInput
                            className="billboard-input-feild"
                            type="number"
                            value={item?.unitQty}
                            onWheel={(e) => e.target.blur()}
                            inputMode="decimal"
                            pattern="[0-9]*"
                            onKeyDown={(e) => {
                              if (["e", "E", "+", "-"].includes(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            label={
                              <>
                                {`Quantity`} {star}
                              </>
                            }
                            onChange={(e) => {
                              let value = e.target.value;
                              value = value.replace(/\D/g, "");
                              // Remove leading zeros
                              value = value.replace(/^0+/, "");
                              const updated = [...availabilityRanges];
                              updated[index].unitQty = value;
                              setAvailabilityRanges(updated);
                              form.setFieldsValue({
                                [`quantity_${index}`]: value,
                              });
                            }}
                            disabled={!selectedArea}
                            customStyles={floatingInputStyles}
                          />
                        </Form.Item>
                      )}
                      {availabilityRanges.length > 1 && (
                        <Delete
                          className="campaign-icons"
                          style={{
                            color: "#d2042d",
                            width: "24px",
                          }}
                          onClick={() => handleRemoveAvailability(index)}
                        />
                      )}
                    </React.Fragment>
                  ))}
                  <Button
                    disabled={!canAddAvailability}
                    className="multiple-slot-add-button"
                    onClick={handleAddAvailability}
                  >
                    <Text className="multiple-slot-add-button-text">
                      {<AddIcon style={{ width: "15px", height: "auto" }} />}{" "}
                      Add Availability
                    </Text>
                  </Button>
                </Col>
              </Row>
              <Row
                className="billboard-form-row"
                style={{ flexWrap: isMobile ? "wrap" : "nowrap" }}
              >
                <Col
                  className="billboard-form-column"
                  style={{ width: isMobile ? "100%" : "32%" }}
                >
                  <Form.Item
                    name="tax_percentage"
                    rules={[
                      {
                        validator: (_, value) => {
                          if (
                            value === undefined ||
                            value === null ||
                            value === ""
                          ) {
                            return Promise.resolve();
                          }
                          if (value < 1 || value > 100) {
                            return Promise.reject(
                              "Tax percentage must be between 1 and 100!",
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <FloatingInput
                      className="billboard-input-feild"
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      inputMode="decimal"
                      pattern="[0-9]*"
                      onKeyDown={(e) => {
                        if (["e", "E", "+", "-"].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      max={100}
                      label={<>{`Tax Percentage `}</>}
                      customStyles={floatingInputStyles}
                    ></FloatingInput>
                  </Form.Item>
                </Col>
                <Col
                  className="billboard-form-column"
                  style={{ width: isMobile ? "100%" : "32%" }}
                >
                  <Form.Item name="fix">
                    <div style={{ height: "3.125rem" }}>
                      <span style={{ fontFamily: "Roboto" }}>
                        Pricing Model
                      </span>
                      <div className="revenue-performance revenue-performance-height">
                        <div
                          className={
                            isVariable
                              ? "revenue-performance-tab-1"
                              : "revenue-performance-tab-2"
                          }
                          onClick={() => {
                            form.setFieldsValue({ fix: "Fixed" });
                            setIsVariable(false);
                          }}
                        >
                          Fixed
                        </div>
                        <div
                          className={
                            isVariable
                              ? "revenue-performance-tab-2"
                              : "revenue-performance-tab-1"
                          }
                          onClick={() => {
                            form.setFieldsValue({ fix: "Variable" });
                            setIsVariable(true);
                          }}
                        >
                          Variable
                        </div>
                      </div>
                    </div>
                  </Form.Item>
                </Col>
                <span></span>
                <Col
                  className="billboard-form-column"
                  style={{ width: isMobile ? "100%" : "32%" }}
                >
                  <Form.Item name="sponsor_yes_no" valuePropName="checked">
                    <div className="billboard-checkbox-div-css">
                      <Checkbox
                        checked={isSponsored}
                        onChange={(e) => {
                          setIsSponsored(e.target.checked);
                          form.setFieldsValue({
                            sponsor_yes_no: e.target.checked,
                          });
                        }}
                      />
                      <span style={{ fontFamily: "Roboto" }}>
                        Sponsored Product
                      </span>
                    </div>
                  </Form.Item>
                </Col>
              </Row>
              <Row
                className="billboard-form-row"
                style={{ flexWrap: isMobile ? "wrap" : "nowrap" }}
              >
                {selectedProductType !== "Digital" && (
                  <Col
                    className="billboard-form-column"
                    style={{ width: isMobile ? "100%" : "32%" }}
                  >
                    <Form.Item
                      name="unitQty"
                      rules={[
                        {
                          required: true,
                          message: "Unit Qty is required!",
                        },
                      ]}
                    >
                      <FloatingInput
                        className="billboard-input-feild"
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        inputMode="decimal"
                        pattern="[0-9]*"
                        onKeyDown={(e) => {
                          if (["e", "E", "+", "-"].includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        label={
                          <>
                            {`Unit Qty `}
                            {star}
                          </>
                        }
                        customStyles={floatingInputStyles}
                      ></FloatingInput>
                    </Form.Item>
                  </Col>
                )}
                {/* <Col
                  className="billboard-form-column"
                  style={{ width: isMobile ? "100%" : "32%" }}
                >
                  <Form.Item name="weekPeriod">
                    <IconFloatingInput
                      className="icon-input-feild"
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      disabled
                      inputMode="decimal"
                      pattern="[0-9]*"
                      onKeyDown={(e) => {
                        if (["e", "E", "+", "-"].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      label={<>{`# of 4-week periods `}</>}
                      customStyles={iconFloatingInputStyles}
                    ></IconFloatingInput>
                  </Form.Item>
                </Col>
                
                 <Col
                  className="billboard-form-column"
                  style={{ width: isMobile ? "100%" : "32%" }}
                >
                  <Form.Item>
                    <FloatingInput
                      value="1"
                      disabled
                      className="billboard-input-feild"
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      inputMode="decimal"
                      pattern="[0-9]*"
                      onKeyDown={(e) => {
                        if (["e", "E", "+", "-"].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      label={<>{` Unit Quantity `}</>}
                      customStyles={floatingInputStyles}
                    ></FloatingInput>
                  </Form.Item>
                </Col> */}
              </Row>
            </div>
            <div>
              <p className="add-billboard-css add-billboard-design">
                PAYMENT TERMS
              </p>
              {/* {!isMobile ? (
                <div className="product-details-section">
                  <div className="info-message">
                    {`These terms are based on the 4-week Price Net Cost - ${formatToUSCurrency(
                      form.getFieldValue("rateCard") || 0,
                    )}`}
                  </div>
                  <Table
                    className="billboard-table"
                    columns={tableColumns}
                    dataSource={paymentTermsData}
                    pagination={false}
                    rowKey="key"
                  />
                  <div className="info-message" style={{ marginTop: "1rem" }}>
                    Make sure your total equals 100%. You can leave any term
                    blank if not applicable.
                    {(rateCardPrice || form.getFieldValue("rateCard")) &&
                      [
                        form.getFieldValue("stripe_percent"),
                        form.getFieldValue("net_15_percent"),
                        form.getFieldValue("net_30_percent"),
                        form.getFieldValue("net_45_percent"),
                        form.getFieldValue("net_60_percent"),
                        form.getFieldValue("net_90_percent"),
                      ].reduce((a, b) => a + (parseFloat(b) || 0), 0) !==
                      100 && (
                        <p
                          className="info-message"
                          style={{ color: "#d2042d" }}
                        >{`Total must be 100% (remaining ${100 -
                          [
                            form.getFieldValue("stripe_percent"),
                            form.getFieldValue("net_15_percent"),
                            form.getFieldValue("net_30_percent"),
                            form.getFieldValue("net_45_percent"),
                            form.getFieldValue("net_60_percent"),
                            form.getFieldValue("net_90_percent"),
                          ].reduce((a, b) => a + (parseFloat(b) || 0), 0)
                          }%)`}</p>
                      )}
                  </div>
                </div>
              ) : (
                <div>
                  <div className="info-message">
                    {`These terms are based on the 4-week Price Net Cost - ${formatToUSCurrency(
                      form.getFieldValue("rateCard") || 0,
                    )}`}
                  </div>
                  {paymentTermsData?.map((header, index) => (
                    <>
                      <p className="add-billboard-design">{header.term}</p>
                      <Row className="billboard-impressions-css">
                        <Col style={{ width: "48%" }}>
                          <Form.Item
                            name={paymentTerms[index]}
                            className="payment-term-form"
                          >
                            <IconFloatingInput
                              innerClassName="inner-payment-term"
                              className="payment-term"
                              addon={false}
                              type="text"
                              min={0}
                              max={100}
                              onKeyDown={(e) => {
                                const invalidChars = [".", "e", "+", "-"];
                                const isAlphabet = /^[a-zA-Z]$/.test(e.key);
                                const isZero =
                                  e.key === "0" && !e.currentTarget.value;
                                if (
                                  invalidChars.includes(e.key) ||
                                  isAlphabet ||
                                  isZero
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              label={<>{`Percentage `}</>}
                              value={
                                form.getFieldValue(paymentTerms[index]) == 0 ||
                                  form.getFieldValue(paymentTerms[index]) == ""
                                  ? ""
                                  : form.getFieldValue(paymentTerms[index])
                              }
                              onChange={(e) => {
                                let value = e.target.value;

                                if (value === "") {
                                  value = "";
                                } else {
                                  if (value > 100) {
                                    value = "";
                                  } else {
                                    const totalWithoutCurrent = Object.entries(
                                      percentages,
                                    ).reduce((acc, [key, val]) => {
                                      if (key !== paymentTerms[index]) {
                                        acc += parseFloat(val) || 0;
                                      }
                                      return acc;
                                    }, 0);

                                    const newTotal =
                                      parseFloat(totalWithoutCurrent) + parseFloat(value);

                                    if (newTotal > 100) {
                                      value = parseFloat(
                                        (100 - parseFloat(totalWithoutCurrent)).toFixed(
                                          getDecimalPlaces(parseFloat(totalWithoutCurrent)),
                                        ),
                                      );
                                    }
                                  }
                                }

                                // Existing code
                                form.setFieldsValue({
                                  [paymentTerms[index]]: value,
                                });

                                PercentageCalculation(paymentTerms[index], value);


                                // ==========================================
                                // ADD THE NEW CODE HERE
                                // ==========================================

                                if (
                                  index === 0 &&
                                  paymentTermsData[0]?.term === "UPFRONT"
                                ) {
                                  const percentageValue = parseFloat(value) || 0;

                                  // Upfront is less than 100%
                                  if (percentageValue > 0 && percentageValue < 100) {
                                    if (paymentTermsData.length === 1) {
                                      setPaymentTermsData([
                                        ...paymentTermsData,
                                        {
                                          key: "2",
                                          term: "",
                                        },
                                      ]);
                                    }
                                  }

                                  // Upfront is 100%
                                  if (percentageValue === 100) {
                                    setPaymentTermsData([
                                      {
                                        key: "1",
                                        term: "UPFRONT",
                                      },
                                    ]);
                                  }
                                }

                              }}
                              onWheel={(e) => e.target.blur()}
                              customStyles={iconPaymentTermsFloatingInputStyles}
                              disabled={
                                (form.getFieldValue("rateCard") ||
                                  rateCardPrice) == 0 ||
                                (totalPercentage === 100 &&
                                  !percentages[paymentTerms[index]]) ||
                                (Object.values(percentages).some(
                                  (val) => val === 100,
                                ) &&
                                  percentages[paymentTerms[index]] === 0)
                              }
                            />
                          </Form.Item>
                        </Col>
                        <Col
                          style={{
                            width: "48%",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <FloatingInput
                            className="billboard-input-feild payment-term-amount"
                            disabled
                            label={<>{`Amount `}</>}
                            style={{ borderRadius: "0.5rem" }}
                            customStyles={floatingInputStyles}
                            value={amounts[paymentTerms[index]] || 0}
                          ></FloatingInput>
                        </Col>
                      </Row>
                    </>
                  ))}
                  <div className="info-message" style={{ marginTop: "1rem" }}>
                    Make sure your total equals 100%. You can leave any term
                    blank if not applicable.
                    {(rateCardPrice || form.getFieldValue("rateCard")) &&
                      [
                        form.getFieldValue("stripe_percent"),
                        form.getFieldValue("net_15_percent"),
                        form.getFieldValue("net_30_percent"),
                        form.getFieldValue("net_45_percent"),
                        form.getFieldValue("net_60_percent"),
                        form.getFieldValue("net_90_percent"),
                      ].reduce((a, b) => a + (parseFloat(b) || 0), 0) !==
                      100 && (
                        <p
                          className="info-message"
                          style={{ color: "#d2042d" }}
                        >{`Total must be 100% (remaining ${100 -
                          [
                            form.getFieldValue("stripe_percent"),
                            form.getFieldValue("net_15_percent"),
                            form.getFieldValue("net_30_percent"),
                            form.getFieldValue("net_45_percent"),
                            form.getFieldValue("net_60_percent"),
                            form.getFieldValue("net_90_percent"),
                          ].reduce((a, b) => a + (parseFloat(b) || 0), 0)
                          }%)`}</p>
                      )}
                  </div>
                </div>
              )} */}
              <div className="product-details-section">
                <div className="info-message">
                  {`These terms are based on the 4-week Price Net Cost - ${formatToUSCurrency(
                    form.getFieldValue("rateCard") || 0,
                  )}`}
                </div>

                <Form.Item
                  name="payment_terms_validation"
                  rules={[
                    {
                      validator: async () => {
                        if (
                          !paymentTermsData ||
                          paymentTermsData.length === 0
                        ) {
                          throw new Error("Payment Terms is required!");
                        }

                        const firstRow = paymentTermsData[0];

                        // First term is required
                        if (!firstRow?.term) {
                          throw new Error("Payment Terms is required!");
                        }

                        const firstPercentage =
                          parseFloat(firstRow?.percentage) || 0;

                        // If Upfront is between 1 and 99,
                        // second term must be selected
                        if (
                          firstRow.term === "Upfront" &&
                          firstPercentage > 0 &&
                          firstPercentage < 100
                        ) {
                          const secondRow = paymentTermsData[1];

                          if (!secondRow?.term) {
                            throw new Error("Payment Terms is required!");
                          }
                        }

                        // Total must equal 100
                        const totalPercentage = paymentTermsData.reduce(
                          (total, item) =>
                            total + (parseFloat(item?.percentage) || 0),
                          0,
                        );

                        if (totalPercentage !== 100) {
                          throw new Error(
                            `Total must be 100% (remaining ${
                              100 - totalPercentage
                            }%)`,
                          );
                        }
                      },
                    },
                  ]}
                >
                  <div>
                    <Table
                      className="billboard-table"
                      columns={tableColumns}
                      dataSource={paymentTermsData}
                      pagination={false}
                      rowKey="key"
                    />
                  </div>
                </Form.Item>

                <div className="info-message" style={{ marginTop: "1rem" }}>
                  Make sure your total equals 100%. You can leave any term blank
                  if not applicable.
                </div>
              </div>
            </div>
            <div>
              <p className="add-billboard-css add-billboard-design">
                VENDOR DETAILS
              </p>
              <Row
                className="billboard-form-row"
                style={{ flexWrap: isMobile ? "wrap" : "nowrap" }}
              >
                <Col
                  className="billboard-form-column"
                  style={{ width: isMobile ? "100%" : "32%" }}
                >
                  <Form.Item name="vendor">
                    <FloatingInput
                      readOnly
                      className="billboard-input-feild"
                      label={<>{`Vendor Name `}</>}
                      customStyles={floatingInputStyles}
                    ></FloatingInput>
                  </Form.Item>
                </Col>
                <Col
                  className="billboard-form-column"
                  style={{ width: isMobile ? "100%" : "32%" }}
                >
                  <Form.Item name="sellerId">
                    <FloatingInput
                      className="billboard-input-feild"
                      label={<>{`Seller ID `}</>}
                      customStyles={floatingInputStyles}
                    ></FloatingInput>
                  </Form.Item>
                </Col>
                <Col
                  className="billboard-form-column"
                  style={{ width: isMobile ? "100%" : "32%" }}
                >
                  <Form.Item name="mediahhi">
                    <IconFloatingInput
                      className="icon-input-feild"
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      inputMode="decimal"
                      pattern="[0-9]*"
                      onKeyDown={(e) => {
                        if (["e", "E", "+", "-"].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      label={<>{`Median `}</>}
                      customStyles={iconFloatingInputStyles}
                    ></IconFloatingInput>
                  </Form.Item>
                </Col>
              </Row>
              <Row
                className="billboard-form-row"
                style={{ flexWrap: isMobile ? "wrap" : "nowrap" }}
              >
                <Col
                  className="billboard-form-column"
                  style={{ width: isMobile ? "100%" : "32%" }}
                >
                  <Form.Item name="audited">
                    <FloatingSelect
                      className="billboard-select-feild"
                      label={<>{`Audited `}</>}
                      options={[
                        { id: "yes", name: "Yes " },
                        { id: "no", name: "No" },
                      ]}
                      customStyles={floatingSelectStyles}
                    />
                  </Form.Item>
                </Col>
                <Col
                  className="billboard-form-column"
                  style={{ width: isMobile ? "100%" : "32%" }}
                >
                  <Form.Item
                    name={
                      form.getFieldValue("billingYes")
                        ? "billingYes"
                        : "billingNo"
                    }
                  >
                    <div style={{ height: "3.125rem" }}>
                      <span
                        style={{ marginRight: "0.5rem", fontFamily: "Roboto" }}
                      >
                        AMP Bills
                      </span>
                      <div className="revenue-performance revenue-performance-height">
                        <div
                          className={
                            ampBills
                              ? "billboard-revenue-performance-tab-1"
                              : "billboard-revenue-performance-tab-2"
                          }
                          onClick={() => {
                            form.setFieldsValue({ billingYes: "yes" });
                            setAmpBills(false);
                          }}
                        >
                          Yes
                        </div>
                        <div
                          className={
                            ampBills
                              ? "billboard-revenue-performance-tab-2"
                              : "billboard-revenue-performance-tab-1"
                          }
                          onClick={() => {
                            form.setFieldsValue({ billingNo: "no" });
                            setAmpBills(true);
                          }}
                        >
                          No
                        </div>
                      </div>
                    </div>
                  </Form.Item>
                </Col>
                <Col
                  className="billboard-form-column"
                  style={{ width: isMobile ? "100%" : "32%" }}
                >
                  <Form.Item
                    name={
                      form.getFieldValue("servicingYes")
                        ? "servicingYes"
                        : "servicingNo"
                    }
                  >
                    <div style={{ height: "3.125rem" }}>
                      <span
                        style={{ marginRight: "0.5rem", fontFamily: "Roboto" }}
                      >
                        AMP Services
                      </span>
                      <div className="revenue-performance revenue-performance-height">
                        <div
                          className={
                            ampServices
                              ? "billboard-revenue-performance-tab-1"
                              : "billboard-revenue-performance-tab-2"
                          }
                          onClick={() => {
                            form.setFieldsValue({ servicingYes: "yes" });
                            form.setFieldsValue({ servicingNo: "" });
                            setAmpServices(false);
                          }}
                        >
                          Yes
                        </div>
                        <div
                          className={
                            ampServices
                              ? "billboard-revenue-performance-tab-2"
                              : "billboard-revenue-performance-tab-1"
                          }
                          onClick={() => {
                            form.setFieldsValue({ servicingNo: "no" });
                            form.setFieldsValue({ servicingYes: "" });
                            setAmpServices(true);
                          }}
                        >
                          No
                        </div>
                      </div>
                    </div>
                  </Form.Item>
                </Col>
              </Row>
              <Row
                className="billboard-form-row"
                style={{ flexWrap: isMobile ? "wrap" : "nowrap" }}
              ></Row>
            </div>
            <div>
              <p className="add-billboard-css add-billboard-design">
                ADDITIONAL INFORMATION
              </p>
              <Row
                className="billboard-form-row"
                style={{ flexWrap: isMobile ? "wrap" : "nowrap" }}
              >
                <Col
                  className="billboard-form-column"
                  style={{ width: isMobile ? "100%" : "32%" }}
                >
                  <Form.Item
                    name="cancellation_policy"
                    rules={[
                      {
                        required: true,
                        message: "Cancellation Policy is required!",
                      },
                    ]}
                  >
                    <FloatingTextArea
                      customStyles={textAreaFloatingInputStyles}
                      label={
                        <>
                          {`Cancellation Policy `}
                          {star}
                        </>
                      }
                      className="billboard-input-feild billboard-text-area"
                    ></FloatingTextArea>
                  </Form.Item>
                </Col>
                <Col
                  className="billboard-form-column"
                  style={{ width: isMobile ? "100%" : "32%" }}
                >
                  <Form.Item
                    name="cancellation_terms"
                    rules={[
                      {
                        required: true,
                        message: "Cancellation Terms is required!",
                      },
                    ]}
                  >
                    <FloatingTextArea
                      customStyles={textAreaFloatingInputStyles}
                      label={
                        <>
                          {`Payment Terms `}
                          {star}
                        </>
                      }
                      className="billboard-input-feild billboard-text-area"
                    ></FloatingTextArea>
                  </Form.Item>
                </Col>
                <Col
                  className="billboard-form-column"
                  style={{ width: isMobile ? "100%" : "32%" }}
                >
                  <Form.Item name="description">
                    <FloatingTextArea
                      customStyles={textAreaFloatingInputStyles}
                      maxLength={500}
                      label={<>{`Description`}</>}
                      className="billboard-input-feild billboard-text-area"
                    ></FloatingTextArea>
                  </Form.Item>
                </Col>
              </Row>
              {selectedProductType !== "Media" && (
                <Row
                  className="billboard-form-row"
                  style={{ flexWrap: isMobile ? "wrap" : "nowrap" }}
                >
                  <Col
                    className="billboard-form-column"
                    style={{ width: isMobile ? "100%" : "32%" }}
                  >
                    <Form.Item name="Comments">
                      <FloatingTextArea
                        customStyles={textAreaFloatingInputStyles}
                        label={<>{`Comments `}</>}
                        className="billboard-input-feild billboard-text-area"
                      ></FloatingTextArea>
                    </Form.Item>
                  </Col>
                </Row>
              )}
            </div>
            <div>
              <p className="add-billboard-css add-billboard-design">
                DEMOGRAPHICS
              </p>
              {!isMobile && (
                <Table
                  className="billboard-table"
                  columns={columns}
                  dataSource={data}
                />
              )}
              {isMobile && (
                <div>
                  {data?.map((header, index) => (
                    <>
                      <p className="add-billboard-design">{header.category}</p>
                      <Row className="billboard-impressions-css">
                        <Col style={{ width: "48%" }}>
                          <FormItem
                            name={impressionNames[index]}
                            rules={
                              index === 1
                                ? [
                                    {
                                      required: true,
                                      message: "Second Impression is required!",
                                    },
                                  ]
                                : []
                            }
                          >
                            <FloatingInput
                              className="billboard-input-feild"
                              type="number"
                              onWheel={(e) => e.target.blur()}
                              inputMode="decimal"
                              pattern="[0-9]*"
                              onKeyDown={(e) => {
                                if (["e", "E", "+", "-"].includes(e.key)) {
                                  e.preventDefault();
                                }
                              }}
                              onChange={(e) => {
                                const cpmValue = cpmCalculation(
                                  e.target.value,
                                  form.getFieldValue("rateCard"),
                                );
                                form.setFieldsValue({
                                  [cpmNames[index]]: `${
                                    cpmValue
                                      ? Number(cpmValue || 0)?.toFixed(2)
                                      : ""
                                  }`,
                                });
                              }}
                              label={
                                index === 1 ? (
                                  <>
                                    {`Impressions `}
                                    {star}
                                  </>
                                ) : (
                                  <>{`Impressions `}</>
                                )
                              }
                              customStyles={floatingInputStyles}
                            />
                          </FormItem>
                        </Col>
                        <Col style={{ width: "48%" }}>
                          <FormItem name={cpmNames[index]}>
                            <IconFloatingInput
                              disabled
                              className="icon-input-feild"
                              value={
                                form.getFieldValue(cpmNames[index]) || "NaN"
                              }
                              label={<>{`CPM `}</>}
                              customStyles={iconFloatingInputStyles}
                            ></IconFloatingInput>
                          </FormItem>
                        </Col>
                      </Row>
                    </>
                  ))}
                </div>
              )}
            </div>
            <div style={{ marginTop: "1rem" }}>
              <div className="billboard-buttons-div ">
                <Button
                  className="billboard-buttons billboard-button-1"
                  onClick={() => {
                    if (mobileOpenDialog) {
                      form.resetFields();
                      setMobileOpenDialog(!mobileOpenDialog);
                    } else {
                      if (openDialog) {
                        form.resetFields();
                        setOpenDialog(!openDialog);
                      }
                    }
                  }}
                >
                  Cancel
                </Button>
                <Button
                  className="billboard-buttons billboard-button-2"
                  onClick={async () => {
                    try {
                      const values = await form.validateFields();

                      const { payment_terms_validation, ...payload } = values;

                      handleSaveDetails(payload);
                    } catch (error) {
                      console.log("Validation failed:", error);
                    }
                  }}
                >
                  Submit
                </Button>
              </div>
            </div>
          </Col>
        </Form>
      </Row>
      {isLoading && (
        <div className="loading-css">
          <Spin size="large" fullscreen />
        </div>
      )}
    </>
  );
};

export default AddBillBoard;
